import { ReactComponent as Caution } from 'styles/images/icon_caution.svg';

const CommonModal = ({ open2, close2, messageType }) => {
  const message = () => {
    switch (messageType) {
      case 'NOT-FOUND':
        return (
          <>
            <Caution />
            <p className='title'>실명확인 불가</p>
            <div className='content'>
              <p>이름과 주민등록번호가 일치하지 않아요.</p>
              <p>
                미성년자 실명인증이 안될 경우 아래 사이트에서 ‘실명등록’을 먼저 해주시거나 고객센터로 문의 부탁드려요.
              </p>
            </div>
            <div className='box'>
              <div className='inner-box'>
                <span>실명등록</span>
                <span>www.niceid.co.kr</span>
              </div>
              <div className='inner-box'>
                <span>고객센터</span>
                <span>1600-1522</span>
              </div>
            </div>
          </>
        );
      case 'INVALID-RS':
        return (
          <>
            <Caution />
            <p className='title'>예약자와의 관계 불일치</p>
            <div className='content'>
              <p>만 14세 미만의 환자는</p>
              <p>보호자 (법정대리인) 확인이 필요하며,</p>
              <p>'자녀' 관계로 선택되어 예약 됩니다</p>
            </div>
          </>
        );
      default:
        return (
          <>
            <Caution />
            <p className='weight-content'>
              입력하신 환자 정보가
              <br />만 14세 미만이 아니에요
            </p>
          </>
        );
    }
  };

  return (
    <div className={'modal-msg ' + (open2 ? 'active' : '')}>
      <div className='modal-msg-box check-name'>
        <div className='msg-box'>{message()}</div>
        <div className='cmd'>
          <button type='button' className='btn_g3 btn_highlight' onClick={close2}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
};
export default CommonModal;
